/* 
* This file is auto-generated by Graphweaver. 
* Please do not edit it directly.
*/
import * as Types from '../../../../../backend/src/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetScanStatsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetScanStatsQuery = { __typename?: 'Query', getScanStats?: { __typename?: 'ScanStats', totalScans: number, totalScansForCouncil: number } | null };


export const GetScanStatsDocument = gql`
    query GetScanStats {
  getScanStats {
    totalScans
    totalScansForCouncil
  }
}
    `;

/**
 * __useGetScanStatsQuery__
 *
 * To run a query within a React component, call `useGetScanStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScanStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScanStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetScanStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetScanStatsQuery, GetScanStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScanStatsQuery, GetScanStatsQueryVariables>(GetScanStatsDocument, options);
      }
export function useGetScanStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScanStatsQuery, GetScanStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScanStatsQuery, GetScanStatsQueryVariables>(GetScanStatsDocument, options);
        }
export function useGetScanStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetScanStatsQuery, GetScanStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetScanStatsQuery, GetScanStatsQueryVariables>(GetScanStatsDocument, options);
        }
export type GetScanStatsQueryHookResult = ReturnType<typeof useGetScanStatsQuery>;
export type GetScanStatsLazyQueryHookResult = ReturnType<typeof useGetScanStatsLazyQuery>;
export type GetScanStatsSuspenseQueryHookResult = ReturnType<typeof useGetScanStatsSuspenseQuery>;
export type GetScanStatsQueryResult = Apollo.QueryResult<GetScanStatsQuery, GetScanStatsQueryVariables>;